import { connect } from '@atlassian/jira-react-redux';
import mapDispatchToProps from './command';
import mapStateToProps from './query';
import View from './view';

// @ts-expect-error - TS2769 - Type 'LoadAction' is not assignable to type 'null | undefined'.
const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(View);
